import { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import './Home.css';
import withAuth from '../components/withAuth';
import MyOpenAppList from '../components/MyOpenAppList';

class MyOpenHome extends Component {
    render() {

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <MyOpenAppList/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser
    };
};
const mapDispatchToProps = () => {
    return {
    };
};
export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps)) (MyOpenHome);
